// Copied from ~/vodalys/vwebrtc3_common/services/vwebrtc3_common_push_wowzalib.es6

import { WowzaPeerConnectionPublish, mungeSDPPublish } from './WowzaWebrtcExemple/index.js'
import { EventEmitter } from './events.esm.js'


export class VWebrtc3Push2WowzaLib extends EventEmitter {
    constructor(wowzaConfig, stream, peerConfig = {}, forceVp8 = false) {

        super()

        // merge default wowzaConfig
        this.wowzaConfig = Object.assign({
            wssUrl: undefined,
            bitrate: 2000
        }, wowzaConfig)

        // merge default peerConfig
        this.peerConfig = Object.assign({
            iceServers: []
        }, peerConfig)

        this.forceVp8 = forceVp8

        // checks
        if (!this.wowzaConfig.wssUrl) {
            throw new Error('Missing Wowza websocket signaling server url (websocket)')
        }
        if (!this.wowzaConfig.streamName) {
            throw new Error('Missing Wowza stream name')
        }
        if (!this.wowzaConfig.applicationName) {
            throw new Error('Missing Wowza application name')
        }
        if (!stream) {
            throw new Error('Missing a stream to push to wowza')
        }

        this.stream = stream

        this._connect()
    }

    async _connect() {
        console.log(this.wowzaConfig)

        // wsURL: string
        //   localStream: MediaStream
        //   streamInfo: { applicationName, streamName }
        //   mediaInfo: { videoBitrate, audioBitrate, videoFrameRate, videoCodec, audioCodec }
        //   userData: any
        //   mungeSDP: function (sdpStr, mungeData)
        //   onconnectionstatechange: function
        //   onerror: function

        WowzaPeerConnectionPublish.start({
            wsURL: this.wowzaConfig.wssUrl,
            localStream: this.stream,
            streamInfo: {
                applicationName: this.wowzaConfig.applicationName,
                streamName: this.wowzaConfig.streamName
            },

            mediaInfo: {
                videoBitrate: '6000',
                audioBitrate: '128',
                videoFrameRate: '30',
                videoCodec: this.forceVp8 ? 'VP8' : '42e01f',
                audioCodec: 'opus'
            },
            // mediaInfo:currentState.mediaInfo,
            userData: { param1: 'value1' },
            mungeSDP: mungeSDPPublish,
            onconnectionstatechange: _ => {
                this.connectionState = _.currentTarget.connectionState
                switch (_.currentTarget.connectionState) {
                    case 'connected':
                        this.emit('connect')
                        break

                }
                this.emit('connectionstatechange', _.currentTarget.connectionState)
            },
            onstop: _ => this.emit('onstop', _),
            // onstats: _ => console.info('onstats', _),
            onerror: _ => this.emit('error', _),
        })
    }

    async destroy() {
        await WowzaPeerConnectionPublish.stop()
    }

    async replaceTrack(type, newTrack) {
        await WowzaPeerConnectionPublish.replaceTrack(type, newTrack)
    }

}